import React, { useState, useMemo, useCallback } from 'react';
import { Tab } from '@headlessui/react';
import clsx from 'clsx';
import StandardAnalytics from '../components/StandardAnalytics/index';
import CustomDateRangePicker from '@appmaker/components/DateRangePicker';
import { useProject } from '@appmaker/core/hooks';

// Memoized navigation array to prevent recreation
const navigation = [{ name: 'Standard' }
		// , { name: 'Advanced' }
];

// Memoized tab button component
const TabButton = React.memo(({ item, selected }) => (
	<button
		className={clsx(
			selected
				? 'bg-blue-700 text-white'
				: 'text-gray-700 hover:text-gray-600 hover:bg-gray-50 border border-gray-200',
			'group w-full flex items-center justify-between gap-x-2 rounded-md px-4 py-3 text-base leading-6 font-semibold'
		)}
	>
		<span className="line-clamp-1">{item.name}</span>
	</button>
));

TabButton.displayName = 'TabButton';

export default function Home() {
	const [dateRange, setDateRange] = useState(() => {
		const today = new Date();
		const endDate = new Date(today);
		endDate.setDate(today.getDate() - 1); // Yesterday (not including today)
		
		const startDate = new Date(today);
		startDate.setDate(today.getDate() - 7); // 7 days ago
		
		return [startDate, endDate];
	});
	const { projectId } = useProject();

	// Memoize date range object to prevent unnecessary re-renders
	const memoizedDateRange = useMemo(() => ({
		startDate: dateRange[0],
		endDate: dateRange[1]
	}), [dateRange]);

	// Memoize date range change handler
	const handleDateRangeChange = useCallback((newDateRange) => {
		setDateRange(newDateRange);
	}, []);

	return (
		<Tab.Group as="div" className="h-screen flex flex-col">
			<nav aria-label="Sidebar" className="px-8 py-4">
				<div className="flex justify-between items-center">
					<Tab.List as="ul" className="flex flex-row gap-4 items-center">
						{navigation.map((item) => (
							<Tab as="li" key={item.name}>
								{({ selected }) => (
									<TabButton item={item} selected={selected} />
								)}
							</Tab>
						))}
					</Tab.List>
					<CustomDateRangePicker
						value={dateRange}
						onChange={handleDateRangeChange}
					/>
				</div>
			</nav>

			<Tab.Panels as="div" className="col-span-10 overflow-y-auto flex-auto">
				<Tab.Panel key={'Standard'}>
					<StandardAnalytics
						dateRange={memoizedDateRange}
						projectId={projectId}
					/>
				</Tab.Panel>
				{/* <Tab.Panel key={'Advanced'}>
					<AdvancedAnalytics />
				</Tab.Panel> */}
			</Tab.Panels>
		</Tab.Group>
	);
}
